// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PriceChartController from "./price_chart_controller"
application.register("price-chart", PriceChartController)

import StockChartController from "./stock_chart_controller"
application.register("stock-chart", StockChartController)

import SearchController from "./search_controller"
application.register("search", SearchController)
    
import ReactController from "./react_controller"
application.register("react", ReactController)

import QuestionFormController from "./question_form_controller"
application.register("question-form", QuestionFormController)

import SnowflakeController from "./snowflake_controller"
application.register("snowflake", SnowflakeController)

import AdminMultiSelectController from "./admin_multi_select_controller"
application.register("admin-multi-select", AdminMultiSelectController)

import StocksTableController from "./stocks_table_controller"
application.register("stocks-table", StocksTableController)
